import { FaLinkedin, FaEnvelope } from "react-icons/fa";

export default function Reseau() {
  return (
    <div className="flex flex-col sm:flex-row lg:grid lg:grid-cols-2 gap-3 sm:gap-4 lg:gap-6 border-2 border-gray-400 p-3 sm:p-4 md:p-6 lg:p-8 xl:p-10 rounded-2xl max-w-2xl mx-auto">

      {/* LinkedIn */}
      <a
        href="https://www.linkedin.com/in/gautier-vasse-366031238/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 sm:gap-3 text-blue-600 lg:text-gray-700 lg:hover:text-blue-600 hover:scale-105 transition duration-300 text-base sm:text-lg md:text-xl font-medium px-2 sm:px-3 py-2 sm:py-3 rounded-xl justify-center sm:justify-start"
      >
        <FaLinkedin className="text-2xl sm:text-3xl flex-shrink-0" />
        <span>LinkedIn</span>
      </a>

      {/* Email */}
      <a
        className="flex items-center gap-2 sm:gap-3 text-red-500 lg:text-gray-700 lg:hover:text-red-500 transition duration-300 text-base sm:text-lg md:text-xl font-medium px-2 sm:px-3 py-2 sm:py-3 rounded-xl justify-center sm:justify-start"
        href="mailto:vasse.gautier@gmail.com"
      >
        <FaEnvelope className="text-xl sm:text-2xl text-black flex-shrink-0" />
        <span className="break-all text-black text-sm sm:text-base md:text-lg">vasse.gautier@gmail.com</span>
      </a>
    </div>
  );
}
